import React, { useCallback, useMemo } from "react";
import { FlatList, ListRenderItem, ScrollViewProps } from "react-native";
import { LIST_ITEM_HEIGHT } from "../../../../mobile/src/features/KPIAdmin/components/ListItem";
import { AHSeparator } from "../AHList/AHSeparator";
import { Box } from "../AHTheme/Box";
import { BoxProps } from "../AHTheme/BoxProps";
import { useBoxStyle } from "../AHTheme/useBoxStyle";

type SelectListItemType = { id: string };

export function SelectList<T extends SelectListItemType>(props: {
  insets: BoxProps["insets"];
  data: readonly T[];

  ListHeaderComponent?: React.ReactElement;
  ListFooterComponent?: React.ReactElement;
  contentBox?: BoxProps;
  renderItem: ListRenderItem<T>;

  keyExtractor?: ((item: T, index: number) => string) | undefined;
  renderScrollComponent?:
    | ((
        props: ScrollViewProps
      ) => React.ReactElement<
        ScrollViewProps,
        string | React.JSXElementConstructor<any>
      >)
    | undefined;
}) {
  const getItemLayout = useCallback(
    (_d: unknown, index: number) => ({
      index,
      length: LIST_ITEM_HEIGHT,
      offset: LIST_ITEM_HEIGHT * index,
    }),
    []
  );

  const contentContainerStyle = useBoxStyle({
    space: "medium",
    spaceTop: "none",
    insets: props.insets,
    ...props.contentBox,
  });

  const ListComponent = useMemo(() => FlatList, []);

  return (
    <ListComponent
      getItemLayout={getItemLayout}
      ListFooterComponent={props.ListFooterComponent}
      ListHeaderComponent={
        props.ListHeaderComponent ? (
          <>
            {props.ListHeaderComponent}
            <ItemSeparatorComponent />
          </>
        ) : undefined
      }
      contentContainerStyle={[contentContainerStyle]}
      renderScrollComponent={props.renderScrollComponent}
      style={{ flex: 1 }}
      data={props.data}
      ItemSeparatorComponent={AHSeparator}
      renderItem={props.renderItem}
      keyExtractor={props.keyExtractor}
    />
  );
}

const ItemSeparatorComponent = () => <Box spaceTop="medium" />;
